<template>
  <div class="card">
    <div class="card-header" role="tab" :id="`heading_${name}`">
        <a data-toggle="collapse" :href="`#collapse_${name}_${suffix}`" aria-expanded="true" :aria-controls="`collapse_${name}_${suffix}`">{{ title }}</a>
    </div>
    <div :id="`collapse_${name}_${suffix}`" class="collapse show" role="tabpanel" :aria-labelledby="`heading_${name}`" data-parent="#accordion">
      <div class="card-body">
         <ul>
            <li v-for="(filter, index) in filters.slice(0, this.min)">
              <ponroy-filter-checkbox :label="filter.label" :count="filter.count" :key="index" :value="filter.selected" @input="selected => update(filter, selected)"></ponroy-filter-checkbox>
            </li>
          </ul>
          <div class="collapse multi-collapse" :id="`subcollapse_${name}_${suffix}`">
            <div class="card card-body">
              <ul>
                <li v-for="(filter, index) in filters.slice(this.min, filters.length)">
                  <ponroy-filter-checkbox :label="filter.label" :count="filter.count" :key="index" :value="filter.selected" @input="selected => update(filter, selected)"></ponroy-filter-checkbox>
                </li>
              </ul>
            </div>
          </div>
          <a v-if="filters.length > this.min" class="lnk" data-toggle="collapse" :href="`#subcollapse_${name}_${suffix}`" aria-expanded="false" :aria-controls="`subcollapse_${name}_${suffix}`">Afficher</a>
      </div>
    </div>
  </div>
</template>

<script>
import PonroyFilterCheckbox from './FilterCheckbox.vue';

import {mapState, mapActions} from 'vuex';
import store from '../store';

export default {
  name: 'ponroy-filter-group',
  store,
  components: {
    PonroyFilterCheckbox
  },
  props: {
    title: String,
    name: String,
    min: Number,
    suffix: String
  },
  computed: mapState('facetedFilter', {
    filters(state) {
      return state.filters[this.name];
    }
  }),
  methods: {
    ...mapActions('facetedFilter', [
        'changeFilterCheckbox'
    ]),
    update(filter, selected) {
      this.changeFilterCheckbox({...filter, group: this.name, selected});
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/SiteBundle/Resources/assets/components/FilterGroup.vue